import React from 'react';
import { IIconProps } from '../interfaces';
const ClockIcon = (props: IIconProps) => {
  return (
      <svg width={props.width} height={props.height} viewBox="0 0 13 14" xmlns="http://www.w3.org/2000/svg"><g transform="translate(.468 .207)" stroke={props.color} fill="none"><ellipse strokeWidth="1.34" cx="6.051" cy="6.402" rx="5.381" ry="5.732"/><path strokeWidth=".893" strokeLinecap="square" d="M6.051 4.432v2.955m0 0h1.911"/></g></svg>
  )
};

export default ClockIcon;